<template>
	<div class="">
		<header-vue></header-vue>
		<div class="container-l">
			<div class="fl eneChart1">
				<div class="chart"></div>
				<div class="chart21">
					<h3>月耗电趋势</h3>
					<div id="chart21" class="full-chart"></div>
				</div>
				<div class="chart21 chart22">
					<h3>高能耗排名</h3>
					<div id="chart22" class="full-chart"></div>
				</div>
			</div>
      <div class="fl eneChart2">
        <div>
          <div class="chart21 chart23">
            <div class="scrollTop clear">
              <div class="scrollBox scrollBox2 scrollBox3">
                <span class="fa fa-bolt"></span>
                <span class="num1">{{lastMonthStatistics.total}}</span>
                <p>上月耗总量</p>
              </div>
              <div class="scrollBox scrollBox2 scrollBox3">
                <span class="fa fa-ravelry"></span>
                <span class="num1">{{lastMonthStatistics.air}}</span>
                <p>空调上月耗电</p>
              </div>
              <div class="scrollBox scrollBox2 scrollBox3">
                <span class="fa fa-microchip"></span>
                <span class="num1">{{lastMonthStatistics.cabinet}}</span>
                <p>机柜上月耗电</p>
              </div>
            </div>
            <div class="scrollTop clear">
              <div class="scrollBox scrollBox2">
                <span class="fa fa-bolt"></span>
                <span class="num1">{{lastYearStatistics.total}}</span>
                <p>去年耗电总量</p>
              </div>
              <div class="scrollBox scrollBox2">
                <span class="fa fa-ravelry"></span>
                <span class="num1">{{lastYearStatistics.air}}</span>
                <p>空调去年耗电</p>
              </div>
              <div class="scrollBox scrollBox2">
                <span class="fa fa-microchip"></span>
                <span class="num1">{{lastYearStatistics.cabinet}}</span>
                <p>机柜去年耗电</p>
              </div>
            </div>
            <div class="chart23-1">
				<h3>能耗详情</h3>
				<div id="chart23" class="full-chart"></div>
            </div>
          </div>
          
        </div>
             
			</div>
      <div class="fr eneChart3">
		<div class="chart21 chart25">
			<h3>日耗电趋势</h3>
			<div id="chart25" class="full-chart"></div>
        </div>
        <div id="chart24" class="chart21 chart24">

        </div>
        
      </div>
      <div class="fl eneChart4">
        <div id="chart26" class="chart21 chart26">

        </div>
        <div id="chart27" class="chart21 chart26">

        </div>
        <div id="chart28" class="chart21 chart26">

        </div>
      </div>
		</div>
	</div>
</template>
<script>
import echarts from "echarts/lib/echarts"
import 'echarts/map/js/china.js';
export default {
  name: 'app',
  data(){
    return {
		dayStatistics:{},
		PUE:1.1,
		cabinetPercent:1,
		hourStatistics:{},
		lastMonthCabinetEnergyTop:{},
		lastMonthStatistics:{},
		lastYearStatistics:{},
		monthStatistics:{},
		threeMonthsEnergyConstitute:[],
		threeMonthsEnergyStatistics:[],
		monthList:[]

    }
  },
  mounted(){
    this.$nextTick(function(){
    	this.getDetail();
  	})
  },

  methods: { 
	  getDetail(){
		  this.monthList = [];
		let valiCodeParams={
			uid:this.getCookie('uid'),
			token:this.getCookie('token'),
			time:Date.parse( new Date()),
			terminalId:4
		};
		
		this.sign2(valiCodeParams);
		this.$ajax.post(this.$store.state.domain2+"/admin/EnergyStatistics/statistics",this.$qs.stringify(valiCodeParams),{
			emulateJSON: true
		}).then(res=>{
			if(res.data.code=="200"){
				this.dayStatistics = res.data.data.dayStatistics || {};
				this.PUE = res.data.data.PUE || 1.1;
				this.cabinetPercent = res.data.data.cabinetPercent || 1;
				this.hourStatistics = res.data.data.hourStatistics || {};
				this.lastMonthCabinetEnergyTop = res.data.data.lastMonthCabinetEnergyTop || {};
				this.lastMonthStatistics = res.data.data.lastMonthStatistics || {};
				this.lastYearStatistics = res.data.data.lastYearStatistics || {};
				this.monthStatistics = res.data.data.monthStatistics || {};
				this.threeMonthsEnergyConstitute = res.data.data.threeMonthsEnergyConstitute || [];
				this.threeMonthsEnergyStatistics = res.data.data.threeMonthsEnergyStatistics || [];
				// 处理数据获取月份列表
				if(this.threeMonthsEnergyStatistics.length){
					
					for(var i=0;i<this.threeMonthsEnergyStatistics.length;i++){
						this.monthList.push(this.threeMonthsEnergyStatistics[i].name)
					}
				}
				this.drawLine();
				// this.$message.success(res.data.msg);
			}else if(res.data.code==10008){
				this.delCookie('username');
				this.$router.push('/login/');
				this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo);
			}else{
				this.$message.error(res.data.msg);
			}
		});
	},
    drawLine(){
        let chart21 = this.$echarts.init(document.getElementById('chart21'));
		        
		      chart21.setOption({
              title: {
				show: false,
				text: '月耗电趋势',
				x:'2%',
				y:"3%",
				textStyle:{
					color:'#eee',
					fontWeight:'normal',
					fontSize:'16'
				}
					  
              },
              tooltip : {
                  trigger: 'axis',
                  axisPointer: {
                      type: 'cross',
                      label: {
                          backgroundColor: '#6a7985'
                      }
                  }
			  },
			  legend: {
					y : "5%",
					// data:['总能耗', 'IT设备能耗','空调能耗','其他']
					textStyle:{
							color: "#eee",
							fontSize: "12"
						},
					data:['总能耗', 'IT设备能耗','空调能耗','其他']
				},
              yAxis: {
				  type: 'value',
				  axisLine: {
						lineStyle: {
							color: '#999'
						}
					},
				//   坐标添加单位
				//   axisLabel: { formatter: '{value}(KWh)' }
              },
              xAxis: {
                  type: 'category',
				  boundaryGap: false,
				  axisLine: {
						lineStyle: {
							color: '#999'
						}
					},
                  data: this.monthStatistics.xAxis || []
                  
              },
              grid: {
                  left: '3%',
                  right: '7%',
                  bottom: '6%',
                  top:"18%",
                  containLabel: true
              },
              
              series: [
				//   {
				// 	name:'总能耗',
				// 	type:'line',
					
				// 	itemStyle: {
				// 		normal: {
				// 			color: '#8ec6ad'
				// 		}
				// 	},
				// 	smooth: true,
				// 	data: this.monthStatistics.total || []
				// },
				{
					name:'IT设备能耗',
					type:'line',
					itemStyle: {
						normal: {
							color: '#0d85f0'
						}
					},
					
					smooth: true,
					data: this.monthStatistics.cabinet || []
					
				},
				{
					name:'空调能耗',
					type:'line',
					itemStyle: {
						normal: {
							color: '#c6973a'
						}
					},
				
					smooth: true,
					data: this.monthStatistics.air || []
					
				},
				{
					name:'其他',
					type:'line',
					itemStyle: {
						normal: {
							color: '#969696'
						}
					},
				
					smooth: true,
					data: this.monthStatistics.other || []
					
				}
                  
              ]
		  });
		//   图表22
		  let chart22 = this.$echarts.init(document.getElementById('chart22'));
		        
		        chart22.setOption({
              title: {
				  show:false,
                  text: '高能耗排名',
                  x:'2%',
					y:"3%",
					textStyle:{
						color:'#eee',
						fontWeight:'normal',
						fontSize:'16'
		              }
              },
              tooltip: {
                  trigger: 'axis',
                  axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                      type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                  }
              },
              xAxis: {
				  type: 'value',
				  axisLine: {
						lineStyle: {
							color: '#999'
						}
					},
              },
              yAxis: {
				  type: 'category',
				  axisLine: {
						lineStyle: {
							color: '#999'
						}
					},
                  data: this.lastMonthCabinetEnergyTop.name || []
                  
              },
              grid: {
                  left: '3%',
                  right: '4%',
                  bottom: '3%',
                  top:"12%",
                  containLabel: true
              },
              
              series: [{
                  data: this.lastMonthCabinetEnergyTop.value || [],
                  type: 'bar',
                  barWidth: '50%',
                  showBackground: true,
                  backgroundStyle: {
                      color: 'rgba(220, 220, 220, 0.8)'
                  },
                  itemStyle: {
                    emphasis: {
                      shadowBlur: 10,
                      shadowOffsetX: 0,
                      shadowColor: 'rgba(0, 0, 0, 0.5)'
                    },
                    normal:{
                      //每个柱子的颜色即为colorList数组里的每一项，如果柱子数目多于colorList的长度，则柱子颜色循环使用该数组
                      //var colorList = ['#31b0d5','#c9302c','#5cb85c','#aaa'];
                      color: function (params){
                        var colorList = ['#c35652','#c35652','#c35652','#d48265','#d48265','#d48265','#d48265','#d48265','#d48265','#d48265','#c35652'];
                        return colorList[params.dataIndex];
                      }
                    }
                  },
              }]
          });
		//   图表24
		        let chart24 = this.$echarts.init(document.getElementById('chart24'));
		        
		        chart24.setOption({
					title: {
					  text: 'IT设备容积率',
		              left:'center',
        			  top:'45%',
		              textStyle:{
						color:'#eee',
						fontWeight:'normal',
						fontSize:'16'
		              }
					},
					tooltip: {
						formatter: '{a} <br/>{b} : {c}%'
					},
					
					series: [
		            {
		              name: '温度',
		              type: 'gauge',
		              center: ['50%', '55%'], // 默认全局居中
		              radius: '75%',
		              min: 0,
		              max: 100,
		              splitNumber: 7,
		              axisLine: { // 坐标轴线
		                lineStyle: { // 属性lineStyle控制线条样式
		                  color: [[0.2, '#17bfff'], [0.8, '#0d80ff'], [1, '#ce6037']],
                                
		                  width: 8,
		                  shadowColor: '#111', //默认透明
		                  shadowBlur: 10
		                }
		              },
		              axisLabel: { // 坐标轴小标记
		                show: false
		              },
		              axisTick: { // 坐标轴小标记
		                length: 12, // 属性length控制线长
		                lineStyle: { // 属性lineStyle控制线条样式
		                  color: 'auto',
		                  shadowColor: '#fff', //默认透明
		                  shadowBlur: 10
		                }
		              },
		              splitLine: { // 分隔线
		                length: 20, // 属性length控制线长
		                lineStyle: { // 属性lineStyle（详见lineStyle）控制线条样式
		                  width: 3,
		                  color: '#fff',
		                  shadowColor: '#fff', //默认透明
		                  shadowBlur: 10
		                }
		              },
		              pointer: {
		                width: 6,
		                shadowColor: '#fff', //默认透明
		                shadowBlur: 5
		              },
		              title: {
		                show: false
		              },
		              detail: {
		                //backgroundColor: 'rgba(30,144,255,0.8)',
		                // borderWidth: 1,
		                formatter: '{value}%',
		                borderColor: '#111',
		                shadowColor: '#111', //默认透明
		                shadowBlur: 5,
		                width: 80,
		                height: 30,
		                //offsetCenter: [25, '20%'],       // x, y，单位px
		                textStyle: { // 其余属性默认使用全局文本样式，详见TEXTSTYLE
		                  
		                  fontSize: 26,
		                }
		              },
		              data: [{
		                value: this.cabinetPercent,
		                name: 'IT设备容积率'
		              }]
		            }
		          ]
				});
          let chart25 = this.$echarts.init(document.getElementById('chart25'));
		        
		      chart25.setOption({
              title: {
				  show: false,
                  text: '日耗电趋势',
                  x:'2%',
					y:"3%",
					textStyle:{
						color:'#eee',
						fontWeight:'normal',
						fontSize:'16'
		              }
              },
              tooltip : {
                  trigger: 'axis',
                  axisPointer: {
                      type: 'cross',
                      label: {
                          backgroundColor: '#6a7985'
                      }
                  }
			  },
			  legend: {
					y : "13%",
					textStyle:{
						color: "#eee",
						fontSize: "12"
					},
					// data:['总能耗', 'IT设备能耗','空调能耗','其他']
					data:['IT设备能耗','空调能耗','其他']
				},
              yAxis: {
				  type: 'value',
				  axisLine: {
						lineStyle: {
							color: '#999'
						}
					},
              },
              xAxis: {
                  type: 'category',
				  boundaryGap: false,
				  axisLine: {
						lineStyle: {
							color: '#999'
						}
					},
                  data: this.dayStatistics.xAxis
                  
              },
              grid: {
                  left: '3%',
                  right: '7%',
                  bottom: '6%',
                  top:"25%",
                  containLabel: true
              },
              
              series: [
					// {
					// 	name:'总能耗',
					// 	type:'line',
						
					// 	itemStyle: {
					// 		normal: {
					// 			color: '#8ec6ad'
					// 		}
					// 	},
					// 	smooth: true,
					// 	data:this.dayStatistics.total || []
					// },
					{
						name:'IT设备能耗',
						type:'line',
						itemStyle: {
							normal: {
								color: '#d68262'
							}
						},
						
						smooth: true,
						data:this.dayStatistics.cabinet || []
						
					},
					{
						name:'空调能耗',
						type:'line',
						itemStyle: {
							normal: {
								color: '#2f4554'
							}
						},
					
						smooth: true,
						data:this.dayStatistics.air || []
						
					},
					{
						name:'其他',
						type:'line',
						itemStyle: {
							normal: {
								color: '#aaa'
							}
						},
					
						smooth: true,
						data:this.dayStatistics.other || []
						
					}
					
				]
                 
              
          });
          // 能耗详情
          let chart23 = this.$echarts.init(document.getElementById('chart23'));
		        // 绘制图表
		        chart23.setOption({
					color:['#0d85f0','#c6973a','#17bfff'],
				    title: {
						show: false,
				    	x:'2%',
		              	y:"3%",
						text: '能耗详情',
						textStyle:{
							color:'#eee',
							fontWeight:'normal',
							fontSize:'16'
						}
				    },
				    tooltip : {
				        trigger: 'axis',
				        axisPointer: {
				            type: 'cross',
				            label: {
				                backgroundColor: '#6a7985'
				            }
				        }
				    },
				    legend: {
						y : "5%",
						textStyle:{
							color: "#eee",
							fontSize: "12"
						},
				        data:['IT设备能耗', '空调能耗','其他']
				    },
				    grid: {
				        left: '3%',
				        right: '4%',
				        bottom: '3%',
				        top:"22%",
				        containLabel: true
				    },
				    xAxis : [
				        {
							type : 'category',
							axisTick: {
								alignWithLabel: true
							},
							axisLine: {
								lineStyle: {
									color: '#999'
								}
							},
				            data : this.hourStatistics.xAxis || []
				        }
				    ],
				    yAxis : [
				        {
							type : 'value',
							axisLine: {
								lineStyle: {
									color: '#999'
								}
							},
				            splitLine: {
					            show: false
					        }
				        }
				    ],
				    series : [
				        {
							name: 'IT设备能耗',
							type: 'bar',
							barWidth: '50%',
							stack: '总量',
							label: {
								show: false
							},
							normal:{		                    
		                    	color:'#c35652'
							},
							data: this.hourStatistics.cabinet || []
						},
						{
							name: '空调能耗',
							type: 'bar',
							stack: '总量',
							label: {
								show: false
							},
							data: this.hourStatistics.air || []
						},
						{
							name: '其他',
							type: 'bar',
							stack: '总量',
							label: {
								show: false
							},
							data: this.hourStatistics.other || []
						}
				    ]
        });
        // 设备电能统计
		let chart26 = this.$echarts.init(document.getElementById('chart26'));
		chart26.setOption({
		          baseOption:{
		            title : {
		              text: '能耗构成',
		              left:'center',
        			  top:'45%',
		              textStyle:{
						color:'#eee',
						fontSize:16,
						fontWeight: 'normal'
		              }
		            },
		            tooltip : {
		              trigger: 'item',
		              formatter: "{a} <br/>{b} : {c} ({d}%)"
		            },
		            grid: {
		              top:'10%'
		            },
		            legend: {
						show:true,
				        orient : 'vertical',
				        x : 'left',
						y : "2%",
						textStyle:{//图例文字的样式
							color:'#eee',
							fontSize:12
						},
				        data:['空调','机柜',"其他"]
				    },
		            series : [
		              {
		                name: '能耗构成',
		                type: 'pie',
		                radius: ['40%', '75%'],
//		              	  替换后台返回数据
						data:this.threeMonthsEnergyConstitute || [],
						label: {
							normal: {
								show: true,
								formatter: "{d}%",
								position : 'inner'
							}
						},
		                itemStyle: {
		                  emphasis: {
		                    shadowBlur: 10,
		                    shadowOffsetX: 0,
		                    shadowColor: 'rgba(0, 0, 0, 0.5)'
		                  },
		                  normal:{
		                    //每个柱子的颜色即为colorList数组里的每一项，如果柱子数目多于colorList的长度，则柱子颜色循环使用该数组
		                    //var colorList = ['#31b0d5','#c9302c','#5cb85c','#aaa'];
		                    color: function (params){
		                      var colorList = ['#3ce2ff','#0d85f0','#c0983a'];
		                      return colorList[params.dataIndex];
		                    }
		                  }
		                }
		              }
		            ]
		          }
		
            });
          // 上一年能耗统计
		        let chart28 = this.$echarts.init(document.getElementById('chart28'));
		    	chart28.setOption({
					title: {
					  text: 'PUE分析',
		              left:'center',
        			  top:'45%',
		              textStyle:{
						color:'#eee',
						fontWeight: 'normal',
						fontSize: '16'
		              }
					},
					tooltip: {
						formatter: '{a} <br/>{b} : {c}'
					},
					
					series: [
		            {
		              name: '温度',
		              type: 'gauge',
		              center: ['50%', '55%'], // 默认全局居中
		              radius: '75%',
		              min: 1,
		              max: 5,
		              splitNumber: 7,
		              axisLine: { // 坐标轴线
		                lineStyle: { // 属性lineStyle控制线条样式
		                  color: [[0.2, '#17bfff'], [0.8, '#0d80ff'], [1, '#ce6037']],
                                
		                  width: 8,
		                  shadowColor: '#111', //默认透明
		                  shadowBlur: 10
		                }
		              },
		              axisLabel: { // 坐标轴小标记
		                show: false
		              },
		              axisTick: { // 坐标轴小标记
		                length: 12, // 属性length控制线长
		                lineStyle: { // 属性lineStyle控制线条样式
		                  color: 'auto',
		                  shadowColor: '#fff', //默认透明
		                  shadowBlur: 10
		                }
		              },
		              splitLine: { // 分隔线
		                length: 20, // 属性length控制线长
		                lineStyle: { // 属性lineStyle（详见lineStyle）控制线条样式
		                  width: 3,
		                  color: '#fff',
		                  shadowColor: '#fff', //默认透明
		                  shadowBlur: 10
		                }
		              },
		              pointer: {
		                width: 6,
		                shadowColor: '#fff', //默认透明
		                shadowBlur: 5
		              },
		              title: {
		                show: false
		              },
		              detail: {
		                //backgroundColor: 'rgba(30,144,255,0.8)',
		                // borderWidth: 1,
		                formatter: '{value}',
		                borderColor: '#111',
		                shadowColor: '#111', //默认透明
		                shadowBlur: 5,
		                width: 80,
		                height: 30,
		                //offsetCenter: [25, '20%'],       // x, y，单位px
		                textStyle: { // 其余属性默认使用全局文本样式，详见TEXTSTYLE
		                  
		                  fontSize: 26,
		                }
		              },
		              data: [{
		                value: this.PUE,
		                name: 'PUE'
		              }]
		            }
		          ]
				});
		        
          // 近期电能统计
		        let chart27 = this.$echarts.init(document.getElementById('chart27'));
		    	chart27.setOption({
		          baseOption:{
		            title : {
		              text: '近三月电能',
		              left:'center',
        			  top:'45%',
		              textStyle:{
		                color:'#eee',
						fontWeight:"normal",
						fontSize:"16"
		              }
		            },
		            tooltip : {
		              trigger: 'item',
		              formatter: "{a} <br/>{b} : {c} ({d}%)"
		            },
		            grid: {
		              top:'10%'
		            },
		            legend: {
						show:true,
				        orient : 'vertical',
				        x : 'left',
				        y : "2%",
						textStyle:{//图例文字的样式
							color:'#eee',
							fontSize:12
						},
				        data:this.monthList || []
				    },
		            series : [
		              {
		                name: '近三月电能',
		                type: 'pie',
		                radius: ['40%', '75%'],
//		              	  替换后台返回数据
                    data:this.threeMonthsEnergyStatistics || [],
					label: {
						normal: {
							show: true,
							formatter: "{d}%",
							position : 'inner'
						}
					},
		                itemStyle: {
		                  emphasis: {
		                    shadowBlur: 10,
		                    shadowOffsetX: 0,
		                    shadowColor: 'rgba(0, 0, 0, 0.5)'
		                  },
		                  normal:{
							
		                    //每个柱子的颜色即为colorList数组里的每一项，如果柱子数目多于colorList的长度，则柱子颜色循环使用该数组
		                    //var colorList = ['#31b0d5','#c9302c','#5cb85c','#aaa'];
		                    color: function (params){
		                      var colorList = ['#0d85f0','#c6973a','#ce6037'];
		                      return colorList[params.dataIndex];
		                    }
		                  }
		                }
		              }
		            ]
		          }
		
		        });
    },
	
  }
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/energyStatistics.vue